import {
  Collapse, TableCell, TableRow, Tooltip,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { FaFileDownload, FaCheckDouble } from 'react-icons/fa';
import { IoMdEye } from 'react-icons/io';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { EmissaoAvulsaIcon } from '../../../assets/Icons/EmissaoAvulsaNFIcon';
import {
  TableIconsInvisible,
  TableActionButton, TableCellCenter, TableCellLeft, TableCellRight,
} from '../../UI/Tabela/tableDefaultStyles';
import TooltipUI from '../../UI/Tooltip/Tooltip';
import { useCCClienteDispatch } from '../../../store/ContaCorrenteCliente/ContaCorrenteClienteProvider';
import { atualizarStatusLidoDadosGeracaoNotaFiscalAction, downloadArquivoRemessaHandlerAction, visualizarPDFRemessaOnClickAction } from '../../../store/ContaCorrenteCliente/contaCorrenteCliente.saga';
import { useUtilStyles } from '../../../helpers';

function TableBodyDadosGeracaoNFComponent({
  content = {}, permissoes, collapse, setCollapse,
}) {
  const dispatch = useCCClienteDispatch();
  const utilStyles = useUtilStyles();

  const alterarStatusLido = useCallback((idNFClienteRemessa) => {
    dispatch(atualizarStatusLidoDadosGeracaoNotaFiscalAction(idNFClienteRemessa));
  }, [dispatch]);

  const downloadArquivo = useCallback(() => {
    dispatch(downloadArquivoRemessaHandlerAction(content.idNotaFiscalClienteRemessa, content.prefeitura));
  }, [dispatch, content.idNotaFiscalClienteRemessa, content.prefeitura]);

  const visualizarPdfRemessaOnClickHandler = useCallback((idNFClienteRemessa) => {
    dispatch(visualizarPDFRemessaOnClickAction(idNFClienteRemessa));
  }, [dispatch]);
  const [expand, setExpanded] = useState(false);

  const gerarDetalhe = useCallback((detalhe) => {
    if (detalhe) {
      return (
        detalhe.map((item, index) => (
          <div key={index} style={{ marginBottom: '10px' }}>
            <p key={index}>
              <b>Nota:</b>
              {item.numeroNota}
              {
            item.erros.map(erro => (
              erro.startsWith('<Mensagem de Alerta>')
                ? (
                  <div>
                    <p>
                      <b>Mensagem de Alerta: </b>
                      {erro?.replace('<Mensagem de Alerta>', '')}
                    </p>
                  </div>
                )
                : (
                  <div>
                    <p>
                      <b>Mensagem de Erro: </b>
                      {erro?.replace('<Mensagem de Erro>', '')}
                    </p>
                  </div>
                )

            ))
          }
            </p>
          </div>
        )));
    }
    return (<></>);
  }, []);

  useEffect(() => {
    if (collapse) {
      setExpanded(false);
      setCollapse(false);
    }
  }, [setExpanded, setCollapse, collapse]);

  return (
    <>
      <TableRow className={utilStyles.tableRowRoot}>
        <TableCellCenter>
          {content.idNotaFiscalClienteRemessa}
        </TableCellCenter>
        <TableCellCenter>
          {
            content.serAvulso
            && <EmissaoAvulsaIcon />
          }
        </TableCellCenter>
        <TableCellCenter>
          {content.data}
        </TableCellCenter>
        <TableCellLeft>
          <TooltipUI title={content.nomeUsuario}>
            <span>
              {content.nomeUsuario}
            </span>
          </TooltipUI>
        </TableCellLeft>
        <TableCellCenter>
          {content.dataLeitura}
        </TableCellCenter>
        <TableCellCenter>
          {content.prefeitura}
        </TableCellCenter>
        <TableCellRight>
          {content.valorTotal}
        </TableCellRight>
        <TableCellCenter>
          <table style={{ width: '-webkit-fill-available' }}>
            <tbody style={{ justifyContent: 'start', display: 'flex' }}>
              <TableIconsInvisible>
                <React.Fragment>
                  <Tooltip title="Download" placement="bottom">
                    <td>
                      <TableActionButton
                        disabled={
                          !permissoes.prestarContas
                          || (content.prefeitura === 'NFe São Paulo' && content.lido)
                        }
                        onClick={() => downloadArquivo()}
                      >
                        <FaFileDownload size={20} />
                      </TableActionButton>
                    </td>
                  </Tooltip>
                </React.Fragment>
                <React.Fragment>
                  <Tooltip title="Visualização" placement="bottom">
                    <td>
                      <TableActionButton
                        onClick={() => visualizarPdfRemessaOnClickHandler(content.idNotaFiscalClienteRemessa)}
                        disabled={!permissoes.prestarContas}
                      >
                        <IoMdEye size={20} />
                      </TableActionButton>
                    </td>
                  </Tooltip>
                </React.Fragment>
                <React.Fragment>
                  {content.lido && (
                    <Tooltip title="Retirar Leitura" placement="bottom">
                      <td>
                        <TableActionButton
                          disabled={!permissoes.prestarContas || (content.prefeitura === 'NFe São Paulo' && content.lido)}
                          onClick={() => alterarStatusLido(content.idNotaFiscalClienteRemessa)}
                        >
                          <FaCheckDouble size={20} />
                        </TableActionButton>
                      </td>
                    </Tooltip>
                  )}
                </React.Fragment>

                <React.Fragment>
                  {content.erros?.length > 0 && (
                  <td>
                    <IconButton size="small" onClick={() => setExpanded(old => !old)} style={{ color: '#034ddc' }}>
                      {expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                  </td>
                  )}
                </React.Fragment>
              </TableIconsInvisible>
            </tbody>
          </table>
        </TableCellCenter>

      </TableRow>
      <TableRow>
        <TableCell colSpan={8} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={expand} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  display: 'flex', marginLeft: '18px', width: '100%', flexDirection: 'column',
                }}
                >
                  {gerarDetalhe(content.erros)}
                </div>
              </div>
            </Box>
          </Collapse>
        </TableCell>

      </TableRow>
    </>
  );
}

export const TableBodyDadosGeracaoNF = TableBodyDadosGeracaoNFComponent;
